import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getjobTemplatesApi, updateGigApi, getGigTitle } from "../../API/API";

function* getTemplatesSaga(action) {
  try {
    const response = yield call(() => getjobTemplatesApi(action.payload)); // API Backend
    yield put({ type: types.GET_JOB_TEMPLATES_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_JOB_LISTING_FAILURE, error });
  }
}

function* updatePostJobsSaga(action) {
  try {
    const response = yield call(() => updateGigApi(action.payload)); // API Backend
    yield put({ type: types.UPDATE_JOBS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.UPDATE_JOBS_FAILURE, error });
  }
}

function* getJobTitleSaga(action) {

  try {
    const response = yield call(() => getGigTitle(action.payload)); // API Backend
    yield put({ type: types.GET_JOB_TITLES_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_JOB_TITLES_FAILURE, error });
  }
}


export function* watchGetTemplatesSaga() {
  yield takeEvery(types.GET_JOB_TEMPLATES_REQUESTED, getTemplatesSaga);
}

export function* watchUpdatePostJobSaga() {
  yield takeEvery(types.UPDATE_JOBS_REQUESTED, updatePostJobsSaga);
}

export function* watchGetJobTitleSaga() {
  yield takeEvery(types.GET_JOB_TITLES_REQUESTED, getJobTitleSaga);
}